<template>
    <div class="record-choose layout-sub-page">
        <!-- 1. 顶部title -->
        <title-bar
            v-bind:titleData="titleData"
            v-bind:backFunc="hideChooseRecord">
        </title-bar>
        <!-- 2. 下拉框和搜索框 -->
        <div class="record-choose-bar dsp-flex">
            <div class="record-choose-side" @click.passive="clickSelectRecord">
                <div class="record-choose-select">
                    <span class="record-choose-select-span">{{curFilterData.text.slice(0, 4)}} <i class="iconfont rob-icon icon-down"></i></span>
                </div>
            </div>
            <div class="record-choose-search">
                <search-input 
                    v-bind:className="'record-choose-input'"
                    v-bind:inputId="searchInputId"
                    v-bind:searchData="searchData"
                    v-bind:inputFunc="inputSearch">
                </search-input>
            </div>
        </div>
        <!-- 3. 列表 -->
        <record-choose-list v-show="searchResultList.length == 0">
        </record-choose-list>

        <!-- 4. 搜索结果显示 -->
        <record-search-list v-show="searchResultList.length > 0">
        </record-search-list>

        <!-- 5. 字母列表 -->
        <letter-side-bar
            v-if="gotRecordData"
            v-show="searchResultList.length == 0">
        </letter-side-bar>

        <router-view></router-view>
    </div>
</template>

<script>
import TitleBar from '../../components/TitleBar.vue'
import SearchInput from '../../components/SearchInput.vue'
import RecordChooseList from '../../layouts/record/RecordChooseList.vue'
import LetterSideBar from '../../layouts/record/LetterSideBar.vue'
import RecordSearchList from '../../layouts/record/RecordSearchList.vue'
import { RECORD_DOM, FAMOUS_DOM } from '../../modules/dom'
export default {
    name: 'ChooseRecord',
    components: { TitleBar, SearchInput, RecordChooseList, LetterSideBar, RecordSearchList },
    computed: {
        gotRecordData() {
            return this.$store.state.record.gotRecordData;
        },
        recordList() {
            return this.$store.state.record.recordListData;
        },
        gotRecordRecentlyData() {
            return this.$store.state.record.gotRecordRecentlyData;
        },
        searchData() {
            return this.$store.state.search.searchData;
        },
        searchResultList() {
            return this.$store.state.search.searchResultList;
        },
        curFilterData() {
            return this.$store.state.allrecord.curFilterData;
        },
        recordLetterList() {
            return this.$store.state.recordletter.recordLetterList;
        },
        chooseFromPage() {
            return this.$store.state.chooserecord.chooseFromPage;
        },
    },
    data() {
        return {
            curPath: '',
            searchInputId: 'chooseSearchInput',
            titleData: {
                'titleText': '选择目标对象',
                'showCancel': false,
                'hideButton': true
            },
        }
    },
    mounted() {
        // 加载完成后,静默加载全部列表数据
        if(!this.gotRecordData){
            this.$store.dispatch('record/initRecordList');
        }
        // 重置搜索模块数据
        this.$store.dispatch('search/resetData');
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 20);
    },
    methods: {
        initDom() {
            this.curPath = this.$router.history.current.path;
            this.$el.style.width = innerWidth + 'px';
            this.$el.style.height = innerHeight + 'px';
            setTimeout(() => {
                RECORD_DOM.resetChooseRecordLetterSideBarStyle();
            }, 100);
        },
        inputSearch(word) {
            this.$store.state.search.searchData.searchText = word;
            if(word != ''){
                this.$store.dispatch('search/confirmSearchInput', word);
            }else{
                this.$store.state.search.searchResultList = [];
                setTimeout(() => {
                    RECORD_DOM.resetChooseRecordLetterSideBarStyle();
                }, 20);
            }
        },
        hideChooseRecord() {
            this.$store.dispatch('allrecord/filterAllRecordList');
            if(this.chooseFromPage == 'famouspediacreate') {
                this.$router.replace('/famouspediacreate')
                FAMOUS_DOM.showFamousPediaCreatePage();
            }
        },
        clickSelectRecord() {
            this.$router.replace('/famouspediacreate/chooserecord/all')
        }
    }
}
</script>